import { Component } from "@angular/core";

@Component({
  selector: "app-diary-week-view",
  templateUrl: "./diary-week-view.component.html",
  styleUrls: ["./diary-week-view.component.css"]
})
export class DiaryWeekViewComponent {
  constructor() {}
}
